module.exports = __webpack_public_path__ + "static/media/arrow-slder.cfb2bc15.svg";